<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" (click)="save()">{{ 'misc.save_btn'  | translate }}</button>
    </div>
  </div>
</ng-template>

<form [formGroup]="form" (submit)="save()" class="row g-3">

  <div class="col-12 col-md-9 order-md-1">
    <div class="card mb-3">
      <div class="card-header">{{ 'authenticated.account.edit.details_card.header' | translate }}</div>
      <div class="card-body">
        <div class="row">

          <div class="col-12 col-lg-6 py-1">
            <app-read-only-static
              [value]="user?.name ?? ''"
              [label]="'authenticated.account.edit.form.name.label' | translate"
            ></app-read-only-static>
          </div>

          <div class="col-12 col-lg-6 py-1">
            <app-read-only-static
              [value]="user?.email ?? ''"
              [label]="'authenticated.account.edit.form.email.label' | translate"
            ></app-read-only-static>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-9 order-md-1">
    <div class="card">
      <div class="card-header">{{ 'authenticated.account.edit.email_signature_card.header' | translate }}</div>
      <div class="card-body">
        <div class="row">

          <div class="col-12 col-lg-6 py-1">
            <app-form-group
              [formControl]="form.controls.email_signature_name"
              label="{{'authenticated.account.edit.form.email_signature_name.label' | translate }}"
            ></app-form-group>
          </div>

          <div class="col-12 col-lg-6 py-1">
            <app-form-group
              [formControl]="form.controls.email_signature_email"
              label="{{'authenticated.account.edit.form.email_signature_email.label' | translate }}"
            ></app-form-group>
          </div>

        </div>
      </div>
    </div>
  </div>

  @if (user?.time_tracking_employee) {
    <div class="col-12 col-md-9 order-md-1">
      <div class="card">
        <div class="card-header">{{ 'authenticated.account.edit.time_tracking_default_value_card.header' | translate }}</div>
        <div class="card-body">
          <div class="row">

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.default_time_tracking_entry_start_time"
                label="{{'authenticated.account.edit.form.default_time_tracking_entry_start_time.label' | translate }}"
                [errorMessages]="{pattern: ('authenticated.account.edit.form.default_time_tracking_entry_start_time.validation_messages.pattern' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.default_time_tracking_entry_end_time"
                label="{{'authenticated.account.edit.form.default_time_tracking_entry_end_time.label' | translate }}"
                [errorMessages]="{pattern: ('authenticated.account.edit.form.default_time_tracking_entry_end_time.validation_messages.pattern' | translate)}"
              ></app-form-group>
            </div>

          </div>
        </div>
      </div>
    </div>
  }
</form>
